module.exports = __webpack_public_path__ + "img/arrow-3.94db86af.svg";